import { jsxs as l, Fragment as d, jsx as r } from "react/jsx-runtime";
import "react";
import '../../assets/GridList.css';const s = {
  "grid-list": "_grid-list_psik9_1",
  "grid-list-header": "_grid-list-header_psik9_9"
};
function n({ children: e, numberOfColumns: t = 2, headerText: i = "" }) {
  return /* @__PURE__ */ l(d, { children: [
    i !== "" && /* @__PURE__ */ r("h3", { className: [s["grid-list-header"], "grid-list-header"].join(" "), children: i }),
    /* @__PURE__ */ r("ul", { className: s["grid-list"], style: { gridTemplateColumns: `repeat(${t}, 1fr)` }, children: e })
  ] });
}
export {
  n as GridList,
  n as default
};
